import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(@Inject(TranslateService) private translate: TranslateService) { }

  setLanguage(lang: string) {
    this.translate.use(lang);
  }
}
